import React from "react";
import {
  Bold,
  Button,
  Copy,
  Icon,
  InternalImage,
  Row,
  Card,
  Spin,
  Title,
  Wrapper
} from "app/NativeComponents/common";

import ButtonLayout from "./ButtonLayout";

import { openMobileSettings } from "app/NativeActions";

const LocationButton = props => {
  if (props.isMobile && props.device == "mobile") {
    if (
      !props.locationNotification.is_background_set &&
      props.locationNotification.is_location_on
    ) {
      return (
        <ButtonLayout
          onPress={() => {
            openMobileSettings();
          }}
          text="Background Location: Off"
          style={{
            marginBottom: 20
          }}
        />
      );
    } else if (
      !props.locationNotification.is_location_on &&
      !props.locationNotification.is_background_set
    ) {
      return (
        <Wrapper
          style={{
            height: 65,
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Button
            onPress={() => {
              openMobileSettings();
            }}
          >
            <Card
              style={{
                padding: 10,
                paddingLeft: 15,
                paddingRight: 15,
                borderRadius: 20,
                backgroundColor: props.colors.error_color
              }}
            >
              <Row>
                <Wrapper>
                  <Row>
                    <Wrapper
                      style={{
                        marginRight: 5,
                        alignItems: "center",
                        justifyContent: "center"
                      }}
                    ></Wrapper>
                    <Wrapper>
                      <Copy style={{ color: props.colors.white_text_color }}>
                        <Bold>Location: Off</Bold>
                      </Copy>
                    </Wrapper>
                  </Row>
                </Wrapper>
              </Row>
            </Card>
          </Button>
        </Wrapper>
      );
    }
  } else {
    return <Wrapper />;
  }
};

export default React.memo(LocationButton);
